/* 

----- Javascript Initialiser ----- 
Handles initialising the various JS modules on page load and after callbacks.
*/

function initialise() {
    // Add listeners.
    listeners();
}

function listeners() {
    // Add component ready listener.
    $(window).on('component-ready', function(event) {
        // Get selector of the component we just got back.
        let selector = event['detail']['selector'];
        // Get the component we just loaded.
        let component = window[event['detail']['component']];
        if (!component) {
            console.error("Initialiser: Failed to load component", selector);
            return false;
        }
        // Is this a utility component, if so we don't need to run the JS initialiser.
        let isUtility = event['detail']['is-utility'];
        if (isUtility) {
            // Some utility components don't require intialisation, so check for the initialise function.
            if (component.hasOwnProperty('initialise')) {
                // Go straight to initialisation as no context is required at this point as these components should be common helper functions.
                let init = component.initialise();
            }
        } else {
            // Is this a callback / ajax request?
            let container = event['detail']['containers'];
            // Get the initialise selector, if a container is supplied otherwise search the entire DOM.
            let elements = (container ? container.find('[' + expressSelectors()[selector]['initialise'] + ']') : $('[' + expressSelectors()[selector]['initialise'] + ']'));
            if (elements) {
                elements.each(function() {
                    // Get element context.
                    let element = $(this);
                    // Initialise.
                    let init = component.initialise(element);
                });
            }
        }
    });
}

var component = $.component = {
    initialise: () => {
        return initialise();
    }
}

export { component };
